export default () => ({
    swiper: null,
    initialized: false,
    init() {
        this.enable();
    },
    enable() {
        this.swiper = new Swiper(this.$refs.bannersCarousel, {
            slidesPerView: 3,
            spaceBetween: 8,
            pagination: false,
            loop: false,
            breakpoints: {
                320: {
                    slidesPerView: 1.25,
                },
                568: {
                    slidesPerView: 1.5,
                },
                1024: {
                    slidesPerView: 2,
                },
                1536: {
                    slidesPerView: 3,
                    spaceBetween: 12,
                },
            },
            autoplay: {
                delay: 333000,
                disableOnInteraction: false,
            },
            keyboard: {
                enabled: true,
            },
            on: {
                init: () => {
                    this.initialized = true;
                },
            },
        });
    },
});